/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reset_ApplicationInputs */



/**
* | output |
* | --- |
* | "Reset Application" |
*
* @param {Reset_ApplicationInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const reset_application = /** @type {((inputs?: Reset_ApplicationInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reset_ApplicationInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Réinitialiser l'application")
	if (locale === "de") return /** @type {LocalizedString} */ ("Anwendung zurücksetzen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Reimposta applicazione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Сбросить приложение")
	if (locale === "es") return /** @type {LocalizedString} */ ("Restablecer aplicación")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("重置应用程序")
	if (locale === "ja") return /** @type {LocalizedString} */ ("アプリケーションをリセットする")
	if (locale === "hi") return /** @type {LocalizedString} */ ("एप्लिकेशन रीसेट करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Redefinir aplicativo")
	return /** @type {LocalizedString} */ ("Reset Application")
});